import React, { useEffect, useState } from 'react';
import Stack from 'react-bootstrap/Stack';
import { DashboardFilter } from './dashboard-filter';
import { filtersExist, getFilterKeys } from '../shared/filters/filter-common';
import { DashboardStaffingFilter } from './dashboard-staffing-filter';
import { isSelectStaffing } from '../../api/dashboards-api';

export const DashboardFiltersContainer = ({ candidates, filtersUpdatedCallback, staffingUpdatedCallback }) => {
  const [displayFilters, setDisplayFilters] = useState(false);
  const [filterKeyUpdated, setFilterKeyUpdated] = useState(undefined);

  const filterChanged = (filterKey) => {
    filtersUpdatedCallback(filterKey);
    setFilterKeyUpdated(filterKey);
  };

  useEffect(() => {
    if (candidates?.length > 0 && filtersExist()) {
      setDisplayFilters(true);
    }
  }, [candidates]);

  return (
    <>
      {(displayFilters || isSelectStaffing()) && (
        <Stack direction="horizontal" className="justify-content-evenly pb-3 d-none d-md-flex">
          <div className="chart-card d-flex w-100 p-0">
            <Stack direction="horizontal" className="justify-content-evenly d-none d-md-flex">
              {isSelectStaffing() && <div className="chart-title pt-0 pe-3">Opening Type</div>}
              <div>
                <DashboardStaffingFilter staffingFilterUpdatedCallback={staffingUpdatedCallback} />
              </div>
              {displayFilters && (
                <>
                  <div className="chart-title pt-1 pb-1 ps-4"> Filters</div>
                  <Stack className="ps-2" direction="horizontal">
                    {getFilterKeys().map((filterKey) => {
                      return (
                        <DashboardFilter
                          key={filterKey}
                          filterUpdated={filterKeyUpdated}
                          filterKey={filterKey}
                          filterUpdatedCallback={filterChanged}
                        />
                      );
                    })}
                  </Stack>
                </>
              )}
            </Stack>
          </div>
        </Stack>
      )}
    </>
  );
};
